import { ApiKy } from './index'
import {
  GetAdminUsersParams,
  GetAdminUsersResponse,
  InviteAdminUserPayload,
  ResendInvitePayload,
  UpdateAdminUserPayload,
} from '~/types/admin-users'

export default class Api extends ApiKy {
  getAdminUsers(params: GetAdminUsersParams) {
    return this.ky
      .get(`${this.url}`, { searchParams: params })
      ?.json<GetAdminUsersResponse>()
  }

  inviteAdminUser(payload: InviteAdminUserPayload) {
    return this.ky.post(`${this.url}/invite`, { json: payload })
  }

  resendInvite(payload: ResendInvitePayload) {
    return this.ky.post(`${this.url}/resend-invite`, { json: payload })
  }

  updateAdminUser(id: string, payload: UpdateAdminUserPayload) {
    return this.ky.patch(`${this.url}/${id}`, { json: payload })
  }

  deleteAdminUser(id: string) {
    return this.ky.delete(`${this.url}/${id}`)
  }
}
